import { ErrorBoundary } from 'react-error-boundary';
import { ReactNode } from 'react';

function Fallback() {
  return (
    <div>
      <h5
        style={{
          color: '#c10000',
          textAlign: 'center',
          fontSize: '42px',
          marginBottom: '20px',
          fontWeight: '300',
        }}
      >
        Что-то пошло не так!
      </h5>
      <p style={{ color: '#c10000', textAlign: 'center', fontSize: '22px' }}>
        Мы работаем над проблемой...
      </p>
    </div>
  );
}

export function ErrorCatcher({ children }: { children: ReactNode }) {
  return <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>;
}
